module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_5.40eac415.jpeg";